export default "__VITE_ASSET__CCImy3Fi__"